import React from 'react';
import Modal from '@ui-components/Modal';
import Button from '@ui-components/Button';

interface DeleteDocumentModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isDeleting: boolean;
  gameInfo?: string;
}

export const DeleteDocumentModal: React.FC<DeleteDocumentModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  isDeleting,
  gameInfo
}) => {
  if (!isOpen) return null;

  return (
    <Modal onExit={onClose}>
      <div className='m-5'>
        <h1 className='font-bold sm:text-xl'>Confermi di voler eliminare questo referto?</h1>
        {gameInfo && (
          <p className='text-sm text-gray-600 mt-2'>Gara: {gameInfo}</p>
        )}
        <h3 className='text-xs sm:text-sm my-3 text-gray-500'>
          Il documento verrà eliminato definitivamente. Non sarà possibile annullare l'operazione.
        </h3>
      </div>
      <div className='w-full flex flex-col sm:flex-row gap-3 justify-between'>
        <Button styleType='white' onClick={onClose} disabled={isDeleting}>
          Annulla
        </Button>
        <Button onClick={onConfirm} submitting={isDeleting}>
          Elimina
        </Button>
      </div>
    </Modal>
  );
};
